/*
  House of Zena — Collection Filtering & Infinite Scroll Subsystem
  Enterprise Hardened & Race-Condition Protected
*/

let activeCollectionAbortController = null

const applyZenaCategoryFiltering = () => {
  const currentUrl = new URL(window.location.href)
  const zenaCat = currentUrl.searchParams.get('filter.zena.category')
  const taxonomyCat = currentUrl.searchParams.get('filter.p.t.category')

  const productCards = document.querySelectorAll('.collection-products .product-list > [role="listitem"]')
  if (!productCards.length) return

  let visibleCount = 0

  productCards.forEach(card => {
    const cardCat = card.dataset.productCategory || ''
    let shouldShow = true

    if (zenaCat === 'mangalsutras') {
      shouldShow = (cardCat === 'mangalsutras')
    } else if (zenaCat === 'hand-chains') {
      shouldShow = (cardCat === 'hand-chains')
    } else if (taxonomyCat === 'aa-6-8' && !zenaCat) {
      // Pure necklaces: hide mangalsutras
      shouldShow = (cardCat === 'necklaces-and-pendants')
    } else if (taxonomyCat === 'aa-6-3' && !zenaCat) {
      // Pure bracelets: hide hand-chains
      shouldShow = (cardCat === 'bracelets')
    }

    if (shouldShow) {
      card.style.display = ''
      visibleCount++
    } else {
      card.style.display = 'none'
    }
  })

  // Synchronize count displays if custom category filter is active
  if (zenaCat || (taxonomyCat && (taxonomyCat === 'aa-6-8' || taxonomyCat === 'aa-6-3'))) {
    document.querySelectorAll('.collection-product-count').forEach(el => {
      el.textContent = `${visibleCount} products`
    })
    document.querySelectorAll('.btn-filters-view-results').forEach(el => {
      el.textContent = `View Results (${visibleCount})`
    })
  }
}
window.applyZenaCategoryFiltering = applyZenaCategoryFiltering

document.addEventListener('DOMContentLoaded', applyZenaCategoryFiltering)
window.addEventListener('kt.collection.loaded', applyZenaCategoryFiltering)

const loadCollection = async () => {
window.loadCollection = loadCollection
  const collectionProducts = document.querySelector('.collection-products')
  const productList = collectionProducts?.querySelector('.product-list')

  if (productList) {
    productList.style.opacity = '.3'
  }

  // Cancel any existing in-flight filter requests
  if (activeCollectionAbortController) {
    activeCollectionAbortController.abort()
  }
  activeCollectionAbortController = new AbortController()

  try {
    // Use Section Rendering API to fetch only needed sections (reduces payload ~80%)
    const currentUrl = new URL(window.location.href)
    const sectionIds = ['collection-products', 'collection-utilities']
    const sectionIdsParam = sectionIds.join(',')
    
    // Attempt section rendering first, fall back to full page
    let fetchUrl = window.location.href
    if (!currentUrl.searchParams.has('sections')) {
      currentUrl.searchParams.set('sections', sectionIdsParam)
      fetchUrl = currentUrl.toString()
    }

    const response = await fetch(fetchUrl, {
      signal: activeCollectionAbortController.signal
    })

    if (!response.ok) {
      window.location.reload()
      return
    }

    const data = await response.text()
    let htmlToParse = data
    try {
      if (data.trim().startsWith('{')) {
        const json = JSON.parse(data)
        htmlToParse = Object.values(json).join('\n')
      }
    } catch (e) {
      // Fallback: keep raw response if parsing fails
    }

    const parser = new DOMParser()
    const newDocument = parser.parseFromString(htmlToParse, 'text/html')

    const newCollectionProducts = newDocument.querySelector('.collection-products')
    if (collectionProducts && newCollectionProducts) {
      collectionProducts.replaceWith(newCollectionProducts)
    } else {
      window.location.reload()
      return
    }

    document.querySelectorAll('.collection-filters-filter').forEach(elem => {
      const newFilter = newDocument.querySelector(`.collection-filters-filter[data-filter-label="${elem.dataset.filterLabel}"]`)
      if (newFilter) elem.replaceWith(newFilter)
    })

    document.querySelectorAll('[data-collection-filter-label]').forEach(elem => {
      const newFilterLabel = newDocument.querySelector(`[data-collection-filter-label][data-filter-label="${elem.dataset.filterLabel}"]`)
      if (newFilterLabel) {
        elem.replaceWith(newFilterLabel)
      } else {
        elem.replaceWith('')
      }
    })

    document.querySelectorAll('.collection-product-count').forEach(elem => {
      const newCount = newDocument.querySelector('.collection-product-count')
      if (newCount) elem.replaceWith(newCount)
    })

    document.querySelectorAll('.btn-filters-view-results').forEach(elem => {
      const newBtn = newDocument.querySelector('.btn-filters-view-results')
      if (newBtn) elem.replaceWith(newBtn)
    })

    document.querySelectorAll('.btn-filters-clear-all').forEach(elem => {
      const newClear = newDocument.querySelector('.btn-filters-clear-all')
      if (newClear) elem.replaceWith(newClear)
    })

    window.dispatchEvent(new CustomEvent('kt.collection.loaded'))

    const newCollectionUtilities = document.querySelector('.collection-utilities')
    const activeProducts = document.querySelector('.collection-products')
    const headerHeight = document.querySelector('#header-group.sticky-top')?.clientHeight || 0

    if (newCollectionUtilities) {
      if (newCollectionUtilities.getBoundingClientRect().top < 0) {
        newCollectionUtilities.style.scrollMarginTop = `${headerHeight}px`
      }
      newCollectionUtilities.scrollIntoView({ behavior: 'smooth' })
    } else if (activeProducts) {
      if (activeProducts.getBoundingClientRect().top < 0) {
        activeProducts.style.scrollMarginTop = `${headerHeight}px`
      }
      activeProducts.scrollIntoView({ behavior: 'smooth' })
    }
  } catch (err) {
    if (err.name !== 'AbortError') {
      if (typeof window.zenaLog === 'function') {
        window.zenaLog('error', 'Failed to load collection products', err)
      }
      if (productList) {
        productList.style.opacity = '1'
      }
      window.location.reload()
    }
  }
}

class CollectionFilters extends HTMLElement {
  constructor () {
    super()

    this.onLoaded = () => {
      this.handleInputs()
      this.handleClearAllBtns()
      this.handlePriceSlider()
    }

    this.handleInputs()
    this.handleClearAllBtns()
    this.handlePriceSlider()

    window.addEventListener('kt.collection.loaded', this.onLoaded)
  }

  connectedCallback () {
    this.handleInputs()
    this.handleClearAllBtns()
    this.handlePriceSlider()
  }

  disconnectedCallback () {
    window.removeEventListener('kt.collection.loaded', this.onLoaded)
  }

  handleInputs () {
    const form = this.querySelector('form')
    if (!form) return

    const isMultiCollection = ['/collections/bestsellers', '/collections/new-arrivals', '/collections/all'].some(p => window.location.pathname.startsWith(p))

    form.querySelectorAll('input').forEach(input => {
      if (input.dataset.filterBound) return
      input.dataset.filterBound = 'true'

      input.addEventListener('change', () => {
        if (input.classList.contains('zena-category-checkbox')) {
          if (!isMultiCollection) {
            // Direct navigation on single category collection pages (e.g. /collections/rings)
            if (input.checked && input.dataset.categoryUrl) {
              window.location.href = input.dataset.categoryUrl
              return
            }
          } else {
            // On multi-category pages (bestsellers, new-arrivals, all):
            if (input.checked) {
              form.querySelectorAll('.zena-category-checkbox').forEach(other => {
                if (other !== input) other.checked = false
              })
            }
          }
        }

        const params = new URLSearchParams(new FormData(form))
        const url = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', url)
        loadCollection()
      })
    })

    if (!isMultiCollection) {
      form.querySelectorAll('.zena-category-checkbox').forEach(input => {
        const label = form.querySelector(`label[for="${input.id}"]`)
        if (label && !label.dataset.navBound) {
          label.dataset.navBound = 'true'
          label.addEventListener('click', (e) => {
            if (input.dataset.categoryUrl && window.location.pathname !== input.dataset.categoryUrl) {
              e.preventDefault()
              window.location.href = input.dataset.categoryUrl
            }
          })
        }
      })
    }
  }

  handleClearAllBtns () {
    this.querySelectorAll('.btn-filters-clear-all').forEach(btn => {
      if (btn.dataset.clearBound) return
      btn.dataset.clearBound = 'true'

      const params = new URLSearchParams(window.location.search)

      for (const key of params.keys()) {
        if (key.includes('filter.')) {
          btn.removeAttribute('hidden')
        }
      }

      btn.addEventListener('click', () => {
        const searchParams = new URLSearchParams(window.location.search)
        for (const key of [...searchParams.keys()]) {
          if (key.includes('filter.')) {
            searchParams.delete(key)
          }
        }

        const url = `${window.location.pathname}?${searchParams.toString()}`
        window.history.replaceState({}, '', url)
        loadCollection()
      })
    })
  }

  async handlePriceSlider () {
    const slider = this.querySelector('.filter-price-group-slider')
    if (!slider) return

    // Inject vendor CSS only once
    if (slider.dataset.vendorCss && !document.querySelector(`link[href="${slider.dataset.vendorCss}"]`)) {
      const link = document.createElement('link')
      link.setAttribute('href', slider.dataset.vendorCss)
      link.setAttribute('rel', 'stylesheet')
      document.head.appendChild(link)
    }

    // Inject vendor JS only once
    if (slider.dataset.vendorJs && !document.querySelector(`script[src="${slider.dataset.vendorJs}"]`)) {
      const script = document.createElement('script')
      script.setAttribute('src', slider.dataset.vendorJs)
      document.head.appendChild(script)
    }

    if (!window.noUiSlider) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }

    if (!window.noUiSlider) return

    const form = slider.closest('form')
    if (!form) return
    const minValueField = form.querySelector('[name="filter.v.price.gte"]')
    const maxValueField = form.querySelector('[name="filter.v.price.lte"]')

    if (!minValueField || !maxValueField) return

    // If slider already exists on this element, destroy before re-initializing
    if (slider.noUiSlider) {
      slider.noUiSlider.destroy()
    }

    window.noUiSlider.create(slider, {
      start: [
        Number(slider.dataset.minValue) || 0,
        Number(slider.dataset.maxValue) || 10000
      ],
      connect: true,
      range: {
        min: Number(slider.dataset.rangeMin) || 0,
        max: Number(slider.dataset.rangeMax) || 10000
      },
      step: 1
    })

    slider.noUiSlider.on('update', (values) => {
      minValueField.value = values[0]
      maxValueField.value = values[1]
    })

    slider.noUiSlider.on('change', () => {
      const event = new Event('change')
      minValueField.dispatchEvent(event)
      maxValueField.dispatchEvent(event)
    })
  }
}
customElements.define('collection-filters', CollectionFilters)

class SortBy extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        this.setUrl(input.value)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    params.delete('page')
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('sort-by', SortBy)

class Pagination extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('a').forEach(elem => {
      elem.addEventListener('click', (event) => {
        event.preventDefault()
        this.setUrl(elem.dataset.newPage)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('page', value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('collection-pagination', Pagination)

class LoadMoreProducts extends HTMLElement {
  constructor () {
    super()

    this.loading = false
    this.btn = this.querySelector('[data-load-more-btn]')
    this.label = this.querySelector('[data-load-more-label]')
    this.spinner = this.querySelector('[data-load-more-spinner]')
    this.btn?.addEventListener('click', () => this.handleClick())

    this.btn?.addEventListener('mouseenter', () => this.prefetchNext(), { once: true })
    this.btn?.addEventListener('touchstart', () => this.prefetchNext(), { once: true, passive: true })
  }

  prefetchNext () {
    const nextUrl = this.getAttribute('data-next-url')
    if (nextUrl && !document.querySelector(`link[href="${nextUrl}"]`)) {
      const link = document.createElement('link')
      link.rel = 'prefetch'
      link.href = nextUrl
      document.head.appendChild(link)
    }
  }

  setLoading (state) {
    this.loading = state
    if (this.btn) this.btn.disabled = state
    this.spinner?.toggleAttribute('hidden', !state)
  }

  getExistingProductUrls () {
    const existing = new Set()
    document.querySelectorAll('.product-card-link, a[href*="/products/"]').forEach(a => {
      try {
        const path = new URL(a.href, window.location.origin).pathname
        existing.add(path)
      } catch (e) {}
    })
    return existing
  }

  insertCrossCategoryDivider (currentList) {
    if (document.querySelector('.zena-cross-category-divider')) return
    const divider = document.createElement('div')
    divider.className = 'col-12 zena-cross-category-divider text-center my-5 py-4'
    divider.innerHTML = `
      <div class="zena-cross-divider-container">
        <span class="zena-cross-divider-pill">EXPLORE MORE CATEGORIES</span>
        <h3 class="zena-cross-divider-heading">Trending Styles You'll Love</h3>
        <p class="zena-cross-divider-subtitle">Discover handcrafted, anti-tarnish & waterproof jewelry from all House of Zena collections</p>
      </div>
    `
    currentList.appendChild(divider)
  }

  async fetchAndAppend (url) {
    try {
      // Ensure preview_theme_id is preserved in AJAX request if present
      const currentParams = new URLSearchParams(window.location.search)
      const previewId = currentParams.get('preview_theme_id')
      let requestUrl = url
      if (previewId) {
        const u = new URL(url, window.location.origin)
        if (!u.searchParams.has('preview_theme_id')) {
          u.searchParams.set('preview_theme_id', previewId)
        }
        requestUrl = u.toString()
      }

      const response = await fetch(requestUrl)
      if (!response.ok) return null

      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')

      const currentAvailableList = document.querySelector('.zena-available-products-grid') || 
                                   this.closest('section, .collection-products, .collection-template')?.querySelector('.product-list') || 
                                   document.querySelector('.collection-products .product-list, .product-list')

      let currentSoldOutList = document.querySelector('#zena-soldout-products-grid') || 
                               document.querySelector('.zena-soldout-products-grid')

      const newAvailableList = doc.querySelector('.zena-available-products-grid')
      const newSoldOutList = doc.querySelector('#zena-soldout-products-grid')
      const legacyNewList = doc.querySelector('.collection-products .product-list, .collection-template .product-list, .product-list, [role="list"].product-list')

      const existingUrls = this.getExistingProductUrls()
      const added = []

      const appendCard = (targetContainer, node) => {
        if (!targetContainer || !node) return false
        const link = node.querySelector('a[href*="/products/"]')
        let isDuplicate = false
        if (link) {
          try {
            const path = new URL(link.href, window.location.origin).pathname
            if (existingUrls.has(path)) {
              isDuplicate = true
            } else {
              existingUrls.add(path)
            }
          } catch (e) {}
        }

        if (!isDuplicate) {
          node.style.opacity = '0'
          node.style.transform = 'translateY(16px)'
          node.style.transition = 'opacity 0.45s ease-out, transform 0.45s ease-out'
          targetContainer.appendChild(node)
          added.push(node)
          return true
        }
        return false
      }

      if (newAvailableList && currentAvailableList) {
        Array.from(newAvailableList.children).forEach(node => {
          appendCard(currentAvailableList, node)
        })

        if (newSoldOutList && newSoldOutList.children.length > 0) {
          const soldOutHeader = document.querySelector('#zena-soldout-header');
          if (soldOutHeader) soldOutHeader.classList.remove('d-none');

          if (!currentSoldOutList) {
            currentSoldOutList = document.createElement('div')
            currentSoldOutList.id = 'zena-soldout-products-grid'
            currentSoldOutList.className = currentAvailableList.className
            currentSoldOutList.classList.remove('zena-available-products-grid')
            currentSoldOutList.classList.add('zena-soldout-products-grid', 'mt-2')
            currentSoldOutList.setAttribute('role', 'list')
            currentSoldOutList.setAttribute('data-grid-type', 'sold-out')
            this.parentNode.insertBefore(currentSoldOutList, this.nextSibling)
          }
          currentSoldOutList.classList.remove('d-none')
          Array.from(newSoldOutList.children).forEach(node => {
            appendCard(currentSoldOutList, node)
          })
        }
      } else if (currentAvailableList && legacyNewList) {
        // Fallback: segregate items based on availability
        Array.from(legacyNewList.children).forEach(node => {
          const isSoldOut = node.classList.contains('is-sold-out') || 
                            node.getAttribute('data-available') === 'false' || 
                            node.querySelector('.btn-sold-out, .product-card--sold-out, [data-available="false"]')
          if (isSoldOut && currentSoldOutList) {
            currentSoldOutList.classList.remove('d-none')
            appendCard(currentSoldOutList, node)
          } else {
            appendCard(currentAvailableList, node)
          }
        })
      }

      requestAnimationFrame(() => {
        added.forEach((node, index) => {
          setTimeout(() => {
            node.style.opacity = '1'
            node.style.transform = 'translateY(0)'
          }, (index % 12) * 30)
        })
      })

      if (window.bootstrap?.Tooltip) {
        added.forEach(node => node.querySelectorAll('[data-bs-toggle="tooltip"]')
          .forEach(el => window.bootstrap.Tooltip.getOrCreateInstance(el)))
      }

      if (typeof window.zenaBalanceBackgrounds === 'function') {
        window.zenaBalanceBackgrounds(currentAvailableList)
      }

      if (typeof window.zenaShiftSoldOutToEnd === 'function') {
        window.zenaShiftSoldOutToEnd(currentAvailableList)
      }

      const nextEl = doc.querySelector('load-more-products[data-next-url]')
      return nextEl ? nextEl.getAttribute('data-next-url') : null
    } catch (e) {
      if (typeof window.zenaLog === 'function') {
        window.zenaLog('error', 'fetchAndAppend error', e)
      }
      return null
    }
  }

  async handleClick () {
    if (this.loading) return
    this.setLoading(true)

    try {
      const nextUrl = this.getAttribute('data-next-url')

      if (nextUrl) {
        const next = await this.fetchAndAppend(nextUrl)
        window.dispatchEvent(new CustomEvent('kt.collection.loaded'))
        if (next) {
          this.setAttribute('data-next-url', next)
          this.setLoading(false)
        } else {
          // Category pagination fully exhausted — replace button with clean Explore Other Categories CTA
          if (!window.location.pathname.includes('/collections/all') && !document.querySelector('.zena-explore-categories-cta')) {
            const exploreWrap = document.createElement('div')
            exploreWrap.className = 'zena-explore-categories-cta d-flex justify-content-center my-8'
            exploreWrap.innerHTML = `
              <a href="/collections/all" class="btn btn-outline-dark px-5 py-2-5 text-decoration-none">
                <span>Explore Other Categories</span>
              </a>
            `
            this.replaceWith(exploreWrap)
          } else {
            this.remove()
          }
        }
      } else {
        this.setLoading(false)
      }
    } catch (e) {
      if (typeof window.zenaLog === 'function') {
        window.zenaLog('error', 'Load more failed', e)
      }
      this.setLoading(false)
    }
  }
}
customElements.define('load-more-products', LoadMoreProducts)
